import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Cardapio from "../pages/cardapio/page";
import Produto from "../pages/produto/page";
import About from "../pages/about/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "cardapio", element: <Cardapio /> },
      { path: "produto/:id", element: <Produto /> },
      { path: "sobre", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;